import React from 'react';
import Marquee from "react-fast-marquee";

const Announcement = ({ globalData }) => {
	let notices = globalData?.general?.notice || [];
	return (
		<>
			<style>{`
				.marquee-item:after{
					content: " | ";
					color: ;
					font-size: 0.8rem;
					padding-left: 0.8rem !important;
					padding-right: 0.8rem !important;
				}
			`}</style>
		
			<div className="announcement-row">
				<span
					className="item-icon"
					style={{
						maskImage: `url('https://img.j189eb.com/jb/h5/assets/images/icon-set/index-theme-icon/index-announcement-icon.svg?v=1729676340443')`,
					}}
				></span>
				<Marquee speed={30} pauseOnClick={true}>
					{ notices.map((item, index) => (
						<div className="marquee-item">{item}</div>
					))}
				</Marquee>
			</div>
		</>
    );
};

export default Announcement;
